import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { color } from "chart.js/helpers";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { useEffect, useState } from "react";
import { Pie } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const options = {
  plugins: {
    datalabels: {
      formatter: (value, ctx) => {
        let sum = ctx.dataset.data.reduce((acc, data) => acc + data, 0);
        let percentage = ((value * 100) / sum).toFixed(2) + "%";
        return percentage;
      },
      color: "#fff",
      font: {
        weight: "",
        size: 10,
      },
    },
  },
};

const PieChart = ({ textOffset = -40, pieData = [], transform }) => {
  const [allData, setAllData] = useState({});
  useEffect(() => {
    if (!allData.length) {
      setAllData({
        labels: pieData.map(({ name }) => name),
        color: pieData.map(({ color }) => color),
        dataset: pieData.map(({ percent }) => percent),
      });
    }
  }, []);
  const data = {
    labels: allData.labels,
    datasets: [
      {
        data: allData.dataset,
        backgroundColor: allData.color,
        borderWidth: 1,
      },
    ],
  };
  return (
    <Pie
      data={data}
      options={{
        plugins: {
          legend: {
            display: false,
          },
          datalabels: {
            formatter: (value, ctx) => {
              let sum = ctx.dataset.data.reduce((acc, data) => acc + data, 0);
              let percentage = (value * 100) / sum + "%";
              return percentage;
            },
            color: "#fff",
            anchor: "center", // Set position of the data labels
            align: "start",
            offset: textOffset,

            font: {
              weight: "500",
              size: 12,
            },
          },
          tooltip: {
            enabled: false,
          },
        },
      }}
      plugins={[ChartDataLabels]}
    />
  );
};

export default PieChart;
